import React from 'react'
import BanImg from '../../../assets/img/common/man.png'
import { Link } from 'react-router-dom'

const Banner = () => {
    return (
        <>
            <section id="banner_one">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="banner_text_one" style={{ backgroundColor: "rgba(233, 85, 0, 0.5)", background: 0.8, padding: "1px" }} >
                                <h1 className="wow flipInX" data-wow-duration="3.0s" data-wow-delay=".3s"> <span className="wow flipInX" data-wow-duration="2.0s" data-wow-delay=".5s"></span></h1>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="hero_img" >
                                {/* <img src={BanImg} alt="img" /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    )
}

export default Banner
